import { ResCollection, ResModel } from '@sysarb/resclient';
import type { QueryCacheNotifyEvent } from '@tanstack/vue-query';
import { useQueryClient } from '@tanstack/vue-query';

export function useTanstackCache(): void {
    const queryClient = useQueryClient();
    const queryCache = queryClient.getQueryCache();

    const resModelSubscriptions = new Set<string>();

    const handler = (): void => {};

    /**
     * Global handling for ResModel subscriptions.
     */
    function handleResModelSubscriptions(event: QueryCacheNotifyEvent): void {
        const resourceId = event.query.meta?.resourceId;
        const type = event.query.meta?.type;
        const subscribe = event.query.meta?.subscribe;

        if (resourceId != null && type === 'resgate' && subscribe === true) {
            const queryData = event.query.state.data;

            if ((queryData instanceof ResModel || queryData instanceof ResCollection) && event.type === 'updated') {
                if (!resModelSubscriptions.has(resourceId)) {
                    try {
                        queryData.on(null, handler);
                        resModelSubscriptions.add(resourceId);
                    } catch (error) {
                        // Resource might have been removed from cache (e.g., when switching pages)
                        // This can happen if the resource was unsubscribed elsewhere or cache was cleared
                        console.warn(`Failed to subscribe to resource ${resourceId}:`, error);
                        // Don't add to subscriptions map if subscription failed
                    }
                }
            }
            if (resModelSubscriptions.has(resourceId) && event.type === 'removed') {
                try {
                    queryData.off(null, handler);
                    resModelSubscriptions.delete(resourceId);
                } catch (error) {
                    // Resource might have been removed from cache, ignore error
                    console.warn(`Failed to unsubscribe from resource ${resourceId}:`, error);
                }
            }
        }
    }

    queryCache.subscribe((event: QueryCacheNotifyEvent) => {
        if (event.query.meta?.type === 'resgate' && event.query.meta.subscribe === true) {
            handleResModelSubscriptions(event);
        }
    });
}
